import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

interface BedData {
  id: number
  name: string
  bed_type: string | null
  room_name: string
  available: boolean
}

export default class extends Controller {
  static targets = ["facilitySelect", "bedSelect", "bedContainer"]

  declare readonly bedSelectTarget: HTMLSelectElement
  declare readonly bedContainerTarget: HTMLElement

  private get bedTomSelect(): TomSelect | undefined {
    const tsController = this.application.getControllerForElementAndIdentifier(
      this.bedSelectTarget,
      "tom-select"
    ) as any
    return tsController?.tomSelect
  }

  async facilityChanged(event: CustomEvent) {
    const facilityId = event.detail?.value
    const ts = this.bedTomSelect

    if (ts) {
      ts.clear()
      ts.clearOptions()
      ts.clearOptionGroups()
    }
    this.bedContainerTarget.classList.add("hidden")

    if (!facilityId) return

    try {
      const response = await fetch(`/shelter/facilities/${facilityId}/beds.json`)
      if (!response.ok) return

      const beds: BedData[] = await response.json()
      const availableBeds = beds.filter((bed) => bed.available)

      if (!ts || availableBeds.length === 0) return

      // Build optgroups from unique room names
      const roomNames = [...new Set(availableBeds.map((b) => b.room_name))]
      roomNames.forEach((roomName) => {
        ts.addOptionGroup(roomName, { label: roomName })
      })

      // Add bed options grouped by room
      availableBeds.forEach((bed) => {
        ts.addOption({
          value: String(bed.id),
          text: `${bed.name}${bed.bed_type ? ` (${bed.bed_type})` : ""}`,
          optgroup: bed.room_name,
        })
      })

      ts.refreshOptions(false)
      this.bedContainerTarget.classList.remove("hidden")
    } catch {
      // silently fail
    }
  }
}
